import React, { useEffect, useState } from "react";
import "../../assets/css/login.css";
import doctorsImg from "../../assets/images/Group 3038.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Login from "../Login";
import LoginPage from "../LoginPage/Login";
import Email from "../Login/Email";
import Mobile from "./Mobile";
import { Col, Row } from "react-bootstrap";
import include from "../../assets/images/include.png";

const SignupHomeComb = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState(false);
  const location = useLocation();
  useEffect(() => {
    if (location?.state?.mobile) {
      setMobile(true);
    }
    if (location?.state?.email) {
      setMobile(false);
    }
  }, [location?.state]);

  return (
    <div className="login-main">
      <div className="content-wrapper">
        <div className="banner-part">
          <div>
            <div
              className="container laptop-logo"
              style={{
                paddingLeft: "5rem",
                paddingRight: "5rem",
                marginBottom: "2rem",
              }}
            >
              <img
                src="https://virtuelife.s3.ap-south-1.amazonaws.com/RecureMe/VirtueLifelogo.svg"
                width={200}
              />
            </div>

            <div className="container main-text"               style={{ paddingLeft: "5rem", paddingRight: "5rem" }}
>
            <h3
                style={{
                  color: "#ff6f48",
                }}
                className=""
              >
                {" "}
                <h1 style={{whiteSpace:"nowrap",
                  fontWeight: "300",
                  fontSize:"24px",marginBottom:"0px"}}>Next-Gen Physio Solutions – 100% Free, Always!</h1>
                <h1 style={{fontWeight: "700",fontSize:"24px"}}>Recover Faster. Treat Smarter. No Cost. </h1>
              </h3>
            </div>
            <div
              className="container text-start "
              style={{ paddingLeft: "5rem", paddingRight: "5rem" }}
            >
             
              <p
                className=""
                style={{
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                What we included ?
              </p>
              <section
                className="include-section"
                style={{ paddingBottom: "1rem" }}
              >
                <div className="">
                  <div
                    className="include-allcontent-section"
                    style={{ marginLeft: "0px" }}
                  >
                     <Row className="justify-content-center">
                      <Col md={12} sm={12}>
                        <div className="include-content-section">
                          <img
                            alt=""
                            className="include-description-container"
                            style={{ width: "26px", height: "26px" }}
                            src={include}
                          />
                          <p
                            className="include-description-text-block"
                            style={{ fontSize: "14px" }}
                          >
                             Unlimited access to expert rehab exercises – A premium library designed by professionals, free forever.
                          </p>
                        </div>
                        <div className="include-content-section">
                          <img
                            alt=""
                            className="include-description-container"
                            style={{ width: "26px", height: "26px" }}
                            src={include}
                          />
                          <p
                            className="include-description-text-block"
                            style={{ fontSize: "14px" }}
                          >
Pre-made physiotherapy treatment plans – Ready-to-use programs to speed up recovery.   </p>
                        </div>
                      </Col>
                      <Col md={12} sm={12}>
                        <div className="include-content-section">
                          <img
                            alt=""
                            className="include-description-container"
                            style={{ width: "26px", height: "26px" }}
                            src={include}
                          />
                          <p
                            className="include-description-text-block"
                            style={{ fontSize: "14px" }}
                          >
Seamless online home exercise programs – Share workouts via app, email, or printable PDFs with ease.                       </p>
                        </div>
                        <div className="include-content-section">
                          <img
                            alt=""
                            className="include-description-container"
                            style={{ width: "26px", height: "26px" }}
                            src={include}
                          />
                          <p
                            className="include-description-text-block"
                            style={{ fontSize: "14px" }}
                          >
Effortless patient & workout management – Keep everything organized in one simple platform.
                          </p>
                        </div>
                        <div className="include-content-section">
                          <img
                            alt=""
                            className="include-description-container"
                            style={{ width: "26px", height: "26px" }}
                            src={include}
                          />
                          <p
                            className="include-description-text-block"
                            style={{ fontSize: "14px" }}
                          >
Exclusive tools to grow your practice – Streamline treatments and enhance patient progress at no cost.                     </p>
                        </div>
                        <div className="include-content-section">
                          <img
                            alt=""
                            className="include-description-container"
                            style={{ width: "26px", height: "26px" }}
                            src={include}
                          />
                          <p
                            className="include-description-text-block"
                            style={{ fontSize: "14px" }}
                          >
100% free with no hidden fees – No subscriptions, no credit card—just powerful physiotherapy tools.   </p>
                        </div>

                   
                      </Col>
                    </Row>

                    <div className="include-content-section">
                          
                          <p
                            className="include-description-text-block"
                            style={{ fontSize: "14px" }}
                          >
No subscriptions. No credit card. Just powerful physiotherapy tools—for free.
   </p>
                        </div>
                  </div>
                </div>
              </section>
              {/* <span
                style={{
                  color: "#ff6f48",
                  fontWeight: "500",
                  fontSize: "13px",
                }}
              >
                is my data safe ?
              </span>{" "}
              <br />
              <span style={{ fontSize: "11px" }}>
                Yes , your data is protected please read our{" "}
                <a
                  href="https://virtuelife.ai/privacy/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "underline", fontWeight: "700" }}
                >
                  Privacy Policy{" "}
                </a>{" "}
              </span> */}

            </div>

            <div className="container main-text" style={{ paddingLeft: "5rem", paddingRight: "5rem",marginTop:"2rem"}} >

            <span style={{fontSize:"11px"}}>
  Copyright © {new Date().getFullYear()} VirtueLife. All rights reserved.
</span>

                <div style={{fontSize:"10px"}}>
                    <span> 
                    <a
              href="https://virtuelife.ai/terms/"
              target="_blank"
              rel="noreferrer"
            >
              Terms of Use
            </a>
             </span> &nbsp;   | &nbsp;
                    <span>  <a
              href="https://virtuelife.ai/privacy/"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a> </span>

                  </div>
            </div>
          </div>
        </div>
        <div className="mobile-logo  text-center py-3">
        <img
                src="https://virtuelife.s3.ap-south-1.amazonaws.com/RecureMe/VirtueLifelogo.svg"
                width={200}
              />
          </div>
        <div className="form-part">
         
          {mobile === true ? (
            <Mobile mobile={mobile} setMobile={setMobile} />
          ) : (
            <Email setMobile={setMobile} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SignupHomeComb;
